
import './App.css';
import {Route, Routes, HashRouter } from "react-router-dom"
import Login from "./page/judge/login.jsx"
import List from "./page/judge/list.jsx"
import Detail from "./page/judge/detail.jsx"
import View from "./page/judge/view.jsx"

// import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'; 

function App() {
  return (
    <div className="App">
      <HashRouter>
        <Routes>
          <Route path="/login" element={<Login/>}></Route>
          <Route path="/list" element={<List/>}></Route>
          <Route path="/detail" element={<Detail/>}></Route>
          <Route path="/view" element={<View/>}></Route>
          <Route path="/" element={<Login/>}></Route>
        </Routes>
      </HashRouter> 
    </div>
  );
  // return (  
  //   <Router>  
  //     <Routes>  
  //       <Route path="/login" element={<Login />} /> 
  //       <Route path="/list" element={<List />} /> 
  //       <Route path="/detail" element={<Detail />} />  
  //       {/* <Route path="/*" element={<Login />} />  */}
  //     </Routes>  
  //   </Router>
  // );  
}

export default App;
